import { useEffect } from 'react'
import { useRouter } from 'next/router'

import { Spinner } from '@wartek-id/spinner'

import PanelProfil from 'app/KinerjaKSPage/components/PanelProfil'
import useSchoolContext from 'app/KinerjaKSPage/hooks/useSchoolContext'
import { useAPIKinerja } from 'api/kinerja/useAPIKinerjaKS'
import { usePengelolaanKinerjaBaseUrl } from 'app/KinerjaShared/hooks/usePengelolaanKinerjaBaseUrl'

export default function KonfirmasiProfil({
  skipEditConfirmation = false,
}: {
  skipEditConfirmation?: boolean
}) {
  const router = useRouter()

  const { profile, isProfileFetched, isLoadingProfile, currentNpsn } =
    useSchoolContext()

  const {
    data: { data: skp } = {},
    isFetched: isSKPFetched,
    isLoading: isSKPLoading,
  } = useAPIKinerja(currentNpsn, {
    enabled: router.isReady && !!currentNpsn,
    useErrorBoundary: false,
  })

  const baseUrl = usePengelolaanKinerjaBaseUrl()
  useEffect(() => {
    if (isSKPFetched && skp?.status !== 'NOT_FOUND') {
      router.push(
        `${baseUrl}/perencanaan${!!currentNpsn ? `?id=${currentNpsn}` : ''}`
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router, skp, isSKPFetched])

  if (isLoadingProfile && isSKPLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spinner data-testid="loading-spinner" />
      </div>
    )
  }

  if (isProfileFetched && skp?.status === 'NOT_FOUND') {
    return (
      <PanelProfil
        profile={profile}
        skipEditConfirmation={skipEditConfirmation}
      />
    )
  }

  return null
}
